import styled from "styled-components/macro";

export const UserProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .user-info-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left-section {
      display: flex;
      align-items: center;
      gap: 4px;

      figure {
        padding: 10px;
        margin: auto;
        border-radius: 50%;
        cursor: pointer;
        width: 40px;
        height: 40px;
        &:hover {
          background-color: var(--Neutral-4);
        }
      }

      h2 {
        color: var(--Neutral-100);
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -0.48px;
      }
      .user-role-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        margin-left: 8px;
        padding: 4px 8px 4px 5px;
        border-radius: 4px;
        background:
          linear-gradient(
            0deg,
            rgba(255, 96, 107, 0.2) 0%,
            rgba(255, 96, 107, 0.2) 100%
          ),
          #fff;

        span {
          color: var(--chart-color-01);
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
          letter-spacing: -0.18px;
        }
      }
    }
  }

  .update-user-dropdown {
    button {
      padding: 10px;
      .left-icon,
      .right-icon {
        svg {
          width: 16px;
          height: 16px;
        }
      }
      span {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.21px;
        text-transform: capitalize;
      }
    }
  }

  .profile-edit-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    bottom: 0;

    button {
      padding: 10px 20px;
    }
  }

  .profile-information-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: calc(100vh - 80px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: var(--Neutral-300);
      border: 1px solid transparent;
      background-clip: content-box;
    }

    &.edit-mode {
      height: calc(100vh - 160px);
    }
  }

  .render-banner-color {
    display: flex;
    flex-direction: column;
    gap: 4px;
    .color-item {
      display: flex;
      align-items: center;
      gap: 8px;

      span {
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }

      p {
        overflow: hidden;
        color: var(--Neutral-100);
        text-overflow: ellipsis;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
      }
    }
  }
`;

export const UserInformationSection = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      padding: 0 14px;
    }

    .static-class {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .subscription-dropdown-container {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  .section-title {
    color: var(--Neutral-100);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.3px;
  }

  .user-details-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding: 0;
    margin: 0;
    list-style: none;

    .common-label {
      display: flex;
      align-items: center;
      gap: 4px;

      > div {
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .profile-info {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    li {
      display: flex;
      flex-direction: column;
      gap: 4px;
      overflow: hidden;

      span {
        color: var(--Neutral-60);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      p {
        color: var(--Neutral-100);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
        text-transform: capitalize;
      }

      a {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--Neutral-100);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;

        &.link_color {
          color: var(--Active-100);
        }
      }
    }
  }

  .edit-info-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;

    .note-info-section {
      display: flex;
      flex-direction: column;
      padding: 8px 12px;
      color: var(--warning-8);
      background-color: var(--warning-8);
      border-radius: 12px;
      span {
        color: var(--warning-100);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }
      p {
        color: var(--Neutral-80);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.12px;
      }
    }

    .brands-input-field {
      height: 80px;
      display: block;
    }
  }
`;

export const UserInfoBadge = styled.div`
  display: grid;
  place-items: center;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 24px;
  border: 1px solid ${(props) => props.color || "var(--warning-100)"};
  color: ${(props) => props.color || "var(--warning-100)"};
  background-color: ${(props) => props.background || "var(--warning-8)"};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.12px;
`;
